//@ts-nocheck
import { isAfter } from 'date-fns';
import { formatDateForAPI } from '../../../utils/dateUtility';

export const buildTripsQueryParams = ({
  filters = {},
  tripStatuses = [],
  enableDisplayStatuses = false,
  take,
  skip
} = {}) => {
  const params = new URLSearchParams();

  if (take !== undefined && take !== null && take !== '') {
    params.set('take', String(take));
  }

  if (skip !== undefined && skip !== null && skip !== '') {
    params.set('skip', String(skip));
  }

  if (filters?.sortModel?.length > 0) {
    params.set('sortBy', filters.sortModel[0].field);
    params.set('sortOrder', filters.sortModel[0].sort);
  }

  if (filters?.search?.trim()) {
    params.set('input', filters.search.trim());
  }

  const statusesToFilter =
    filters?.statuses?.length > 0 ? filters.statuses : [];

  if (statusesToFilter.length > 0) {
    const statusCodes = [];
    const statusIds = [];

    statusesToFilter.forEach((selectedStatusId) => {
      const status = tripStatuses.find(
        (tripStatus) =>
          String(tripStatus.tripstatusid) === String(selectedStatusId)
      );

      if (!status) return;

      const code = status.tripstatuscode?.toUpperCase();
      if (enableDisplayStatuses) {
        if (code) statusCodes.push(code);
      } else {
        statusIds.push(String(status.tripstatusid));
      }
    });

    if (statusIds.length > 0) {
      params.set('statusId', statusIds.join(';'));
    }

    if (statusCodes.length > 0) {
      params.set('statusCode', statusCodes.join(';'));
    }
  } else if (filters?.viewTripsMode === 'active') {
    if (enableDisplayStatuses) {
      params.set(
        'statusCode',
        ['PROPOSAL', 'CONFIRMED', 'ACTIVE', 'TRAVELING'].join(';')
      );
    } else {
      const inactiveStatusCodes = new Set(['CANCELLED', 'ARCHIVED']);
      const activeStatusIds = (tripStatuses || [])
        .filter((status) => {
          const code = status?.tripstatuscode?.toUpperCase();
          return code && !inactiveStatusCodes.has(code);
        })
        .map((status) => String(status.tripstatusid));

      if (activeStatusIds.length > 0) {
        params.set('statusId', activeStatusIds.join(';'));
      }
    }
  }

  if (filters?.destination) {
    if (filters.destination.cityId) {
      params.set('cityId', String(filters.destination.cityId));
    } else if (filters.destination.countryId) {
      params.set('countryId', String(filters.destination.countryId));
    }
  }

  if (filters?.createdBy?.userid) {
    params.set('createdByUserId', String(filters.createdBy.userid));
  }

  if (filters?.tripDates?.[0] && filters?.tripDates?.[1]) {
    if (!isAfter(filters.tripDates[0], filters.tripDates[1])) {
      const startDate = formatDateForAPI(filters.tripDates[0]);
      const endDate = formatDateForAPI(filters.tripDates[1]);
      params.set('tripDates', `${startDate};${endDate}`);
    }
  }

  if (filters?.lastModified?.[0] && filters?.lastModified?.[1]) {
    if (!isAfter(filters.lastModified[0], filters.lastModified[1])) {
      const startDate = formatDateForAPI(filters.lastModified[0]);
      const endDate = formatDateForAPI(filters.lastModified[1]);
      params.set('lastModified', `${startDate};${endDate}`);
    }
  }

  return params;
};

export default buildTripsQueryParams;
